import { gql } from '@apollo/client';

export const GET_USER_INTERACTION_FEED = gql`
  query GetUserInteractionFeed(
    $userId: String!
    $interaction: InteractionType!
    $cursor: String
    $limit: Int
  ) {
    getUserInteractionFeed(
      userId: $userId
      interaction: $interaction
      cursor: $cursor
      limit: $limit
    ) {
        posts {
            id
            userId
            username
            author {
                authorId
                username
            }
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            postAnalytics {
                id
                author {
                    username
                    authorId
                }
                metrics {
                    replies
                    votes {
                        upVotes
                        downVotes
                    }
                    hidden
                    reportedPost {
                        reportedTimes
                        causes
                    }
                    votesCount {
                        upVotes
                        downVotes
                    }
                    replyCount
                    repostCount
                    bookmarkCount
                }
            }
            article
            createdAt
            updatedAt
            # Viewer-specific fields
            viewerInteractions {
                hasLiked
                hasReposted
                hasBookmarked
                likeCount
                bookmarkCount
            }
            # If it's a reply, include parent post info
            replyTo {
                id
                author {
                    username
                }
            }
            # Why this post appears in feed - NOW INCLUDED
            feedMetadata {
                entryType
                reason
                relevanceScore
                categories  # If appeared due to category interest
                mutualUsers {  # If appeared due to mutual interactions
                    id
                    username
                }
            }
            parentPostId
            rootPostId
            depth
            replyCount
            score
            lastRepliedAt
        }
        pageInfo {
            hasNextPage
            endCursor
            totalCount
        }
    }
  }
`;
